import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Apify, ApifyFullScreenLoadingComponent } from '../Apify';
import { TinyStockCard } from '../c/ChartCard';
import { T } from '../traks';

import SearchField from '../c/SearchField';
import { PortfolioExploreCard, StockExploreCard } from './Explore.js';
import { SponsorBanner } from '../c/SponsorBanner.js';

const G = (props) => props.children;

var ExploreUS = (props) => {
	var sections = [];

	sections.push(
		<Row key="vndjcgfbiurgmj0i" className="align-items-center">
			<Col xs="12" className="pb-3">
				<h3 className="pt-5"><T>US Collections</T></h3>
			</Col>
			<PortfolioExploreCard id={115} card_img="/gfx/dow-jones-350x136-0.svg" name="Dow Jones" href="/portfolio/115"/>
			<PortfolioExploreCard id={118} card_img="/gfx/sp500-350x136-0.svg" name="S&P 500" href="/portfolio/118"/>
			<PortfolioExploreCard id={117} card_img="/gfx/nasdaq-350x136-0.svg" name="Nasdaq" href="/portfolio/117"/>
			<PortfolioExploreCard id={116} card_img="/gfx/fang-350x136-0.svg" name="FANG" href="/portfolio/116"/>
			<Container className="p-0">
				<SponsorBanner
					mode="iframe"
					sponsorName="Codan"
					iframeDesktopUrl="https://adops.bt.dk/stockgame/codan/desktop/index.html"
					iframeMobileUrl="https://adops.bt.dk/stockgame/codan/mobile/index.html"
				/>
			</Container>
			<Col xs="12" className="pb-3">
				<h3><T>Selected US stocks</T></h3>
			</Col>
			<StockExploreCard ticker="SPOT" exchange="NYSE" card_img="/gfx/spotify-350x136-0.svg" name="Spotify" href="/ticker/NYSE/SPOT"/>
			<StockExploreCard ticker="CAT" exchange="NYSE" card_img="/gfx/caterpillar-350x136-0.svg" name="Caterpillar" href="/ticker/NYSE/CAT"/>
			<StockExploreCard ticker="KO" exchange="NYSE" card_img="/gfx/coca-cola-350x136-0.svg" name="Coca-Cola" href="/ticker/NYSE/KO"/>
			<StockExploreCard ticker="TWTR" exchange="NYSE" card_img="/gfx/twitter-350x136-0.svg" name="Twitter" href="/ticker/NYSE/TWTR"/>
			<StockExploreCard ticker="TSLA" exchange="NASDAQ" card_img="/gfx/tesla-350x136-0.svg" name="Tesla" href="/ticker/NASDAQ/TSLA"/>
			<StockExploreCard ticker="IBM" exchange="NYSE" card_img="/gfx/ibm-350x136-0.svg" name="IBM" href="/ticker/NYSE/IBM"/>
			<StockExploreCard ticker="MA" exchange="NYSE" card_img="/gfx/mastercard-350x136-0.svg" name="Mastercard" href="/ticker/NYSE/MA"/>
			<StockExploreCard ticker="V" exchange="NYSE" card_img="/gfx/visa-350x136-0.svg" name="Visa" href="/ticker/NYSE/V"/>
			<StockExploreCard ticker="MCD" exchange="NYSE" card_img="/gfx/mcdonalds-350x136-0.svg" name="McDonalds" href="/ticker/NYSE/MCD"/>
		</Row>

	);

	for (const section of props.home.Sections) {
		var items = [];

		const mk_stock_item = (asset) => {
			const key = `STOCK:${asset.Exchange}:${asset.Ticker}`;
			return (
				<Col key={key} className="pb-4 col-sm-6 col-md-6 col-xl-4 col-md-6 col-lg-4 col-12">
					<TinyStockCard
						exchange={asset.Exchange}
						ticker={asset.Ticker}
                        name={asset.Name}
						range="3m"
					/>
				</Col>
			);
		};

		switch (section.Type) {
			case "STOCKS":
				items = section.Content.map(mk_stock_item);
				break;
			default:
				continue;
		}
		sections.push(
				<span key="SPANNING_ALL">
				<Row key={section.Type}>
					<Col xs="12" className="pb-3">
						<h3><T>Random US stocks</T></h3>
					</Col>
				</Row>
				<Row>
					{items}
				</Row>
				</span>
		);
	}

	const placeholder = <T>Search US assets</T>;

	return (
		<G>
			<div className="d-flex flex-column p-5 text-center ad_game_box justify-content-center">
				<div className="ad_explore_txt_header"><T>United States of America</T></div>
				<div className="pb-3 ad_explore_txt_subheader"><T>Explore assets exclusively from the US</T></div>
				<SearchField placeholder={placeholder} market="US_STOCK" form_classes="justify-content-center pt-2" input_classes="ad_search_explore_page ad_no_outline_focus" input_id="search_field_1"/>
			</div>
			<Container>
				{sections}
			</Container>
		</G>
	);
}

ExploreUS = Apify("/z/explore?market=US_STOCK")
	.with_response_prop("home")
	.wrap(ExploreUS, ApifyFullScreenLoadingComponent);

export default ExploreUS;



// WEBPACK FOOTER //
// ./src/p/ExploreUS.js